
import { useState } from 'react';

export default function CaseStudiesSection() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const categories = ['All', 'Finance', 'Healthcare', 'Aerospace', 'Enterprise', 'Government'];
  
  const caseStudies = [
    {
      id: 1,
      title: 'Digital Banking Platform Redesign',
      category: 'Finance',
      industry: 'Finance & Banking',
      description: 'Redesigned a comprehensive digital banking platform serving 2M+ users, improving transaction completion rates by 45% and reducing customer support tickets by 60%.',
      image: 'https://public.readdy.ai/ai/img_res/62b04864319b8f3b359fd43f4ec26576.jpg',
      tags: ['UX Research', 'UI Design', 'Prototyping', 'User Testing'],
      results: ['45% increase in transaction completion', '60% reduction in support tickets', '35% improvement in user satisfaction']
    },
    {
      id: 2,
      title: 'Healthcare Management System',
      category: 'Healthcare',
      industry: 'Healthcare Technology',
      description: 'Designed an integrated healthcare management system for hospitals, streamlining patient care workflows and reducing administrative overhead by 40%.',
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20management%20system%20interface%20on%20tablet%2C%20medical%20dashboard%20with%20patient%20data%20and%20charts%2C%20clean%20white%20and%20blue%20medical%20UI%20design%2C%20hospital%20technology%20interface%2C%20healthcare%20professional%20using%20digital%20system%2C%20modern%20medical%20software%20design&width=600&height=400&seq=healthcare-case&orientation=landscape',
      tags: ['Healthcare UX', 'Workflow Design', 'Data Visualization', 'Accessibility'],
      results: ['40% reduction in admin overhead', '25% faster patient processing', '90% staff adoption rate']
    },
    {
      id: 3,
      title: 'Aerospace Mission Control Interface',
      category: 'Aerospace',
      industry: 'Aerospace & Defense',
      description: 'Created a mission-critical control interface for aerospace operations, enhancing operational efficiency and reducing human error in complex flight operations.',
      image: 'https://readdy.ai/api/search-image?query=Aerospace%20mission%20control%20center%20interface%2C%20multiple%20screens%20displaying%20flight%20data%20and%20satellite%20information%2C%20high-tech%20control%20room%20environment%2C%20professional%20aerospace%20technology%20dashboard%2C%20dark%20theme%20with%20blue%20accents%2C%20mission%20critical%20interface%20design&width=600&height=400&seq=aerospace-case&orientation=landscape',
      tags: ['Mission Critical Design', 'Real-time Data', 'Safety Standards', 'Complex Systems'],
      results: ['30% reduction in operational errors', '50% faster decision making', '99.9% system reliability']
    },
    {
      id: 4,
      title: 'Enterprise Resource Planning Suite',
      category: 'Enterprise',
      industry: 'Enterprise Software',
      description: 'Developed a comprehensive ERP solution for manufacturing companies, integrating multiple business processes into a unified, intuitive platform.',
      image: 'https://readdy.ai/api/search-image?query=Enterprise%20resource%20planning%20software%20interface%2C%20business%20dashboard%20with%20analytics%20and%20workflow%20management%2C%20professional%20corporate%20software%20design%2C%20data%20visualization%20charts%20and%20graphs%2C%20modern%20ERP%20system%20interface%2C%20clean%20business%20application%20UI&width=600&height=400&seq=enterprise-case&orientation=landscape',
      tags: ['Enterprise UX', 'Process Optimization', 'Integration Design', 'Scalability'],
      results: ['35% improvement in workflow efficiency', '50% reduction in training time', '95% user adoption']
    },
    {
      id: 5,
      title: 'Insurance Claims Processing Platform',
      category: 'Finance',
      industry: 'Insurance Technology',
      description: 'Streamlined insurance claims processing with an intuitive platform that reduced claim processing time by 65% and improved customer satisfaction scores.',
      image: 'https://readdy.ai/api/search-image?query=Insurance%20claims%20processing%20software%20interface%2C%20professional%20insurance%20technology%20dashboard%2C%20claim%20forms%20and%20documentation%20system%2C%20clean%20business%20application%20design%2C%20insurance%20industry%20software%20UI%2C%20modern%20claims%20management%20interface&width=600&height=400&seq=insurance-case&orientation=landscape',
      tags: ['Process Automation', 'Document Management', 'Customer Journey', 'Compliance'],
      results: ['65% faster claim processing', '80% reduction in paperwork', '92% customer satisfaction']
    },
    {
      id: 6,
      title: 'E-Mobility Fleet Management',
      category: 'Enterprise',
      industry: 'E-Mobility & Transportation',
      description: 'Designed a comprehensive fleet management system for electric vehicles, optimizing routes and energy consumption for sustainable transportation.',
      image: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20fleet%20management%20dashboard%2C%20EV%20charging%20station%20monitoring%20interface%2C%20sustainable%20transportation%20technology%2C%20green%20energy%20management%20system%2C%20modern%20mobility%20app%20design%2C%20electric%20vehicle%20tracking%20interface&width=600&height=400&seq=emobility-case&orientation=landscape',
      tags: ['IoT Integration', 'Real-time Tracking', 'Energy Optimization', 'Sustainability'],
      results: ['30% improvement in energy efficiency', '45% reduction in operational costs', '25% increase in fleet utilization']
    },
    {
      id: 7,
      title: 'Government Digital Services Portal',
      category: 'Government',
      industry: 'Government & Public Services',
      description: 'Created a citizen-centric digital services portal for government agencies, improving accessibility and reducing service delivery time by 70%.',
      image: 'https://readdy.ai/api/search-image?query=Government%20digital%20services%20portal%20interface%2C%20citizen%20services%20dashboard%2C%20public%20sector%20technology%20platform%2C%20accessible%20government%20website%20design%2C%20civic%20technology%20interface%2C%20modern%20public%20service%20digital%20platform&width=600&height=400&seq=government-case&orientation=landscape',
      tags: ['Accessibility', 'Public Service Design', 'Multi-language Support', 'Compliance'],
      results: ['70% faster service delivery', '85% improvement in citizen satisfaction', '60% reduction in office visits']
    },
    {
      id: 8,
      title: 'Electronics Manufacturing Dashboard',
      category: 'Enterprise',
      industry: 'Electronics & Manufacturing',
      description: 'Developed a real-time manufacturing dashboard for electronics production, providing insights that improved production efficiency by 40%.',
      image: 'https://readdy.ai/api/search-image?query=Electronics%20manufacturing%20dashboard%20interface%2C%20industrial%20production%20monitoring%20system%2C%20factory%20automation%20control%20panel%2C%20manufacturing%20analytics%20dashboard%2C%20industrial%20IoT%20interface%2C%20production%20line%20management%20system&width=600&height=400&seq=electronics-case&orientation=landscape',
      tags: ['Industrial Design', 'Real-time Monitoring', 'Production Analytics', 'Quality Control'],
      results: ['40% improvement in production efficiency', '25% reduction in defects', '50% faster quality control']
    },
    {
      id: 9,
      title: 'Smart Building Management System',
      category: 'Enterprise',
      industry: 'Smart Buildings & IoT',
      description: 'Designed an intelligent building management system that optimizes energy consumption and enhances occupant comfort through IoT integration.',
      image: 'https://readdy.ai/api/search-image?query=Smart%20building%20management%20system%20interface%2C%20IoT%20dashboard%20for%20building%20automation%2C%20energy%20management%20control%20panel%2C%20intelligent%20building%20technology%2C%20facility%20management%20software%2C%20modern%20building%20automation%20interface&width=600&height=400&seq=buildings-case&orientation=landscape',
      tags: ['IoT Design', 'Energy Management', 'Automation', 'Sustainability'],
      results: ['35% reduction in energy consumption', '50% improvement in maintenance efficiency', '90% occupant satisfaction']
    },
    {
      id: 10,
      title: 'Data Center Operations Platform',
      category: 'Enterprise',
      industry: 'Data Centers & Infrastructure',
      description: 'Created a comprehensive data center management platform that improved operational efficiency and reduced downtime by 80%.',
      image: 'https://readdy.ai/api/search-image?query=Data%20center%20management%20dashboard%2C%20server%20monitoring%20interface%2C%20infrastructure%20management%20system%2C%20network%20operations%20center%20display%2C%20data%20center%20technology%20interface%2C%20server%20room%20monitoring%20dashboard&width=600&height=400&seq=datacenter-case&orientation=landscape',
      tags: ['Infrastructure Design', 'Monitoring Systems', 'Alert Management', 'Performance Analytics'],
      results: ['80% reduction in downtime', '45% improvement in response time', '99.9% system availability']
    },
    {
      id: 11,
      title: 'Food Safety Compliance Platform',
      category: 'Enterprise',
      industry: 'Food & Beverage',
      description: 'Developed a food safety and compliance tracking system that ensures regulatory compliance and improves quality control processes.',
      image: 'https://readdy.ai/api/search-image?query=Food%20safety%20compliance%20software%20interface%2C%20quality%20control%20dashboard%20for%20food%20industry%2C%20food%20production%20monitoring%20system%2C%20regulatory%20compliance%20platform%2C%20food%20safety%20tracking%20interface%2C%20modern%20food%20industry%20technology&width=600&height=400&seq=food-case&orientation=landscape',
      tags: ['Compliance Design', 'Quality Assurance', 'Traceability', 'Regulatory Standards'],
      results: ['100% regulatory compliance', '60% reduction in quality issues', '40% faster audit processes']
    },
    {
      id: 12,
      title: 'Military Command & Control System',
      category: 'Government',
      industry: 'Military & Defense',
      description: 'Designed a secure command and control system for military operations, enhancing situational awareness and decision-making capabilities.',
      image: 'https://readdy.ai/api/search-image?query=Military%20command%20and%20control%20interface%2C%20defense%20technology%20dashboard%2C%20tactical%20operations%20center%20display%2C%20military%20communications%20system%2C%20secure%20defense%20interface%2C%20strategic%20command%20center%20technology&width=600&height=400&seq=military-case&orientation=landscape',
      tags: ['Security Design', 'Mission Critical', 'Real-time Intelligence', 'Tactical Interface'],
      results: ['50% improvement in response time', '90% enhancement in situational awareness', '99.9% system security']
    }
  ];

  const filteredCaseStudies = selectedCategory === 'All' 
    ? caseStudies 
    : caseStudies.filter(study => study.category === selectedCategory);

  return (
    <section id="case-studies" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Case Studies & 
            <span className="text-blue-600"> Success Stories</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our portfolio of transformative UX design projects across diverse industries. 
            Each case study demonstrates our commitment to solving complex challenges with user-centered solutions.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {filteredCaseStudies.map((study) => (
            <div key={study.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
              <div className="relative overflow-hidden">
                <img 
                  src={study.image}
                  alt={study.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {study.industry}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{study.title}</h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{study.description}</p>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {study.tags.map((tag, index) => (
                    <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
                
                <div className="space-y-2 mb-6">
                  <h4 className="font-semibold text-gray-900 text-sm">Key Results:</h4>
                  {study.results.slice(0, 2).map((result, index) => (
                    <div key={index} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {result}
                    </div>
                  ))}
                </div>
                
                <button className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
                  <i className="ri-eye-line mr-2"></i>
                  View Case Study
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <button className="bg-gray-900 text-white px-8 py-4 rounded-lg hover:bg-gray-800 transition-colors font-medium whitespace-nowrap cursor-pointer">
            <i className="ri-download-line mr-2"></i>
            Download Complete Portfolio
          </button>
        </div>
      </div>
    </section>
  );
}
